import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const LinkedIn: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        d='M12.845 9.50653C16.6953 9.51428 16.6661 9.51615 16.9299 9.55927C18.4313 9.80462 19.6795 10.451 20.6829 11.4929C21.5208 12.363 22.1194 13.4883 22.3577 14.6335C22.4241 14.9529 22.4492 15.0126 22.4641 15.5056C22.48 16.0321 22.4799 17.0003 22.4846 19.111L22.4924 22.4919H17.4924L17.4856 19.8044C17.4815 18.0313 17.4835 17.1951 17.4612 16.7585C17.45 16.5389 17.4312 16.3762 17.386 16.2302C17.3454 16.0992 17.2733 15.9688 17.2493 15.9186C16.9854 15.3691 16.4838 14.8966 15.9211 14.6784C15.7975 14.6305 15.636 14.5873 15.4963 14.5573C15.3646 14.529 15.1966 14.4997 15.0686 14.4997H14.5002V22.4919H9.50024V9.49969L12.845 9.50653ZM6.50806 9.49969V22.4919H1.50806V9.49969H6.50806ZM2.50024 21.4997H5.49243V10.4919H2.50024V21.4997ZM11.2258 10.4997C11.1552 10.5005 11.0974 10.5015 11.0559 10.5026C11.0358 10.5032 11.0147 10.5046 10.9973 10.5056C10.9896 10.506 10.975 10.5068 10.9592 10.5085C10.9522 10.5093 10.9347 10.511 10.9133 10.5153C10.9031 10.5174 10.8792 10.5224 10.8508 10.5319C10.8437 10.5343 10.7449 10.5638 10.6565 10.652C10.5728 10.7356 10.543 10.8274 10.5393 10.8376C10.5291 10.8661 10.5231 10.8894 10.5208 10.9001C10.5158 10.9228 10.5137 10.9415 10.5129 10.9479C10.5111 10.9632 10.5103 10.976 10.51 10.9811C10.5092 10.9938 10.5084 11.007 10.5081 11.0173C10.5073 11.0392 10.5067 11.0687 10.5061 11.1032C10.5049 11.1732 10.5042 11.2743 10.5032 11.402C10.501 11.6586 10.4989 12.0282 10.4973 12.4821C10.4941 13.3902 10.4924 14.6403 10.4924 16.0124V21.4997H13.5081V13.5085L14.2825 13.5143C15.0102 13.5195 15.3437 13.523 15.5686 13.5456C15.7616 13.565 15.8602 13.5966 16.134 13.6901C17.2365 14.0666 18.1064 15.0076 18.3918 16.1306C18.4445 16.3376 18.4662 16.4114 18.4797 16.7116C18.4947 17.0433 18.4962 17.6096 18.5012 18.7878L18.511 21.0016L18.5129 21.4997H21.5002V18.4138C21.5002 16.9044 21.4907 15.7065 21.4739 15.5192C21.2866 13.4568 19.9659 11.6717 18.054 10.905C17.6409 10.7393 17.2675 10.6367 16.7874 10.5554C16.6449 10.5313 16.4581 10.5222 16.0471 10.5153C15.6247 10.5083 14.9322 10.5044 13.7542 10.4997C13.0043 10.4967 12.3199 10.4955 11.8215 10.4968C11.5726 10.4974 11.3685 10.4981 11.2258 10.4997ZM6.50806 1.98798V7.01239H1.50806V1.98798H6.50806ZM2.50024 5.99579H5.49243V3.0036H2.50024V5.99579Z'
        fill={fill}
        stroke={fill}
      />
    </svg>
  )
}

export default LinkedIn
